import { useEffect } from "react";
import { imgUrl } from "@/lib/api";

// Google reads this to match product pages with Merchant Center listings.
export const ProductJsonLd = ({ product }) => {
  useEffect(() => {
    const url = `https://pettokshop.net/product/${product.slug}`;
    const data = {
      "@context": "https://schema.org/",
      "@type": "Product",
      sku: product.slug,
      name: product.name,
      ...(product.brand && { brand: { "@type": "Brand", name: product.brand } }),
      ...(product.gtin && { gtin: product.gtin }),
      ...(product.mpn && { mpn: product.mpn }),
      description: product.description || product.name,
      image: [product.image, ...(product.gallery || [])].map(imgUrl),
      offers: {
        "@type": "Offer",
        url,
        priceCurrency: "USD",
        price: Number(product.price).toFixed(2),
        priceValidUntil: `${new Date().getFullYear() + 1}-12-31`,
        seller: { "@type": "Organization", name: "PetTok Shop" },
        availability: "https://schema.org/InStock",
        itemCondition: "https://schema.org/NewCondition",
        shippingDetails: {
          "@type": "OfferShippingDetails",
          shippingRate: { "@type": "MonetaryAmount", value: product.price >= 50 ? "0" : "5.99", currency: "USD" },
          shippingDestination: { "@type": "DefinedRegion", addressCountry: "US" },
          deliveryTime: {
            "@type": "ShippingDeliveryTime",
            handlingTime: { "@type": "QuantitativeValue", minValue: 1, maxValue: 2, unitCode: "DAY" },
            transitTime: { "@type": "QuantitativeValue", minValue: 3, maxValue: 5, unitCode: "DAY" },
          },
        },
        hasMerchantReturnPolicy: {
          "@type": "MerchantReturnPolicy",
          applicableCountry: "US",
          returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
          merchantReturnDays: 30,
          returnMethod: "https://schema.org/ReturnByMail",
          returnFees: "https://schema.org/FreeReturn",
        },
      },
    };
    if (product.rating?.count) {
      data.aggregateRating = { "@type": "AggregateRating", ratingValue: Number(product.rating.average).toFixed(1), reviewCount: product.rating.count, bestRating: 5, worstRating: 1 };
    }
    if (product.top_reviews?.length) {
      data.review = product.top_reviews.map((r) => ({
        "@type": "Review",
        reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5, worstRating: 1 },
        author: { "@type": "Person", name: r.name || "Verified buyer" },
        datePublished: r.created_at,
        reviewBody: r.text,
      }));
    }
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => el.remove();
  }, [product]);
  return null;
};
